import { createSelector, Selector } from '@reduxjs/toolkit';
import { selectShared } from '../sharedSelectors';
import { tSharedAppState, tSharedStore } from '../types';

const selectLessonStore: Selector<tSharedAppState, tSharedStore['lesson']> =
  createSelector([selectShared], (state) => state.lesson);

const selectLesson: Selector<tSharedAppState, tSharedStore['lesson']['data']> =
  createSelector([selectLessonStore], (lessonStore) => lessonStore.data);

const selectLessonSession: Selector<tSharedAppState, tSharedStore['lesson']['session']> =
  createSelector([selectLessonStore], (lessonStore) => lessonStore.session);

const selectLessonPhrases: Selector<tSharedAppState, tSharedStore['lesson']['phrases']> =
  createSelector([selectLessonStore], (lessonStore) => lessonStore.phrases);

const selectSessionResults: Selector<
  tSharedAppState,
  tSharedStore['lesson']['sessionResults']
> = createSelector([selectLessonStore], (lessonStore) => lessonStore.sessionResults);

const selectLessonGameplays: Selector<
  tSharedAppState,
  tSharedStore['lesson']['gameplays']
> = createSelector([selectLessonStore], (lessonStore) => lessonStore.gameplays);

const selectPreviewLessonId: Selector<tSharedAppState, number | null> = createSelector(
  [selectLessonStore],
  (lessonStore) => lessonStore.preview?.lessonId ?? null
);

const lessonSelectors = {
  selectPreviewLessonId,
  selectLessonStore,
  selectLesson,
  selectLessonSession,
  selectLessonPhrases,
  selectSessionResults,
  selectLessonGameplays
};

export default lessonSelectors;
